import { render, staticRenderFns } from "./WizardStepCard.vue?vue&type=template&id=7906810e&scoped=true&"
import script from "./WizardStepCard.vue?vue&type=script&lang=js&"
export * from "./WizardStepCard.vue?vue&type=script&lang=js&"
import style0 from "./WizardStepCard.vue?vue&type=style&index=0&id=7906810e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7906810e",
  null
  
)

export default component.exports